import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { get, post } from '../../services/Services';
import { BsFillSendFill } from 'react-icons/bs';
import { BsFillXCircleFill } from 'react-icons/bs';
import "bootstrap/dist/css/bootstrap.min.css";
import SuccessModal from "../performance/SuccessModal";  // Importamos el modal
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";

const PerformanceForm = ({ onSuccess, onclose, eventId, registrationId, schoolId }) => {
  const [eventoDetalles, setEventoDetalles] = useState(null);
  
  const [formData, setFormData] = useState({
    nombre: '',
    categoria: '',
    modalidad: '',
    formas: '',
    duration: '', // Duración obtenida de la categoría
    musicTheme: 'Default',
    
  });
  const [participants, setParticipants] = useState([]);//constante que almacena los miembros que pueden ser participantes / bailarines / coreografos / preparadores
  const [selectedParticipants, setSelectedParticipants] = useState([]);// constante que almacena los participantes seleccionados
  const [loading, setLoading] = useState(false);//const [registrationId, setregistrationId] = useState(null);
  const [error, setError] = useState(null);
  const [isChoreography, setIsChoreography] = useState(false);//almacena el valor de si es o no una coreografia
  const token = localStorage.getItem("accessToken");

  const [errors, setErrors] = useState({});
  const [maxTime, setMaxTime] = useState(null);
  const [idformselected, setIdformselected] = useState(null);
  const [idcategoryselected, setIdcategoryselected] = useState(null);
  const [formDetails, setFormDetails] = useState(null); // Detalles de la forma seleccionada
  const [isRegistrationDisabled, setIsRegistrationDisabled] = useState(false); // Estado para deshabilitar el botón
  const [totalPrice, setTotalPrice] = useState(0);
  const [dancePerformanceOrder, setDancePerformanceOrder] = useState("");
  const [hasatrainer, sethastrainer] = useState(false);//si tiene preparador
  const [trainer, setTrainer] = useState(null);
  const [trainers, setTrainers] = useState([]);
  const [hasacoregrapher, sethascoreographer] = useState(false);//si tiene coreografo
  const [coregrapher, setCoreographer] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false); // Estado para el modal
  
  /*Área de useEffect*/
  //calcula el precio total
  useEffect(() => {
    if (eventoDetalles && eventoDetalles.config) {
      const pricePerParticipant = eventoDetalles?.config?.forms?.find((forma) => forma.id === parseInt(formData.formas))?.price || 0;
      const priceChoreography = eventoDetalles.config.priceChoreography || 0;
  
      // Si está seleccionada la coreografía, agregar su precio al total
      const total = selectedParticipants.length * pricePerParticipant + (isChoreography ? priceChoreography : 0);
      
      setTotalPrice(total);  // Actualizar el precio total con coreografía si está seleccionada
      console.log(total);  // Mostrar el precio total en consola para ver si se calcula correctamente
    }
  }, [selectedParticipants, formData.formas, eventoDetalles, isChoreography]);
  
  


  // Obtener detalles de la forma seleccionada
  useEffect(() => {
    const fetchFormDetails = async () => {
      if (!idformselected) return;

      try {
        const response = await get(`https://ectech-software.com.ar/api/academy/forms/${idformselected}`);
        setFormDetails(response.data); // Guardar detalles de la forma
      } catch (error) {
        console.error("Error al obtener detalles de la forma:", error);
      }
    };

    fetchFormDetails();
  }, [idformselected]);

  // Obtener la duración válida al seleccionar categoría y forma
  useEffect(() => {
    const fetchValidTime = async () => {
      if (!idcategoryselected || !idformselected) return;

      try {
        const response = await get(`https://ectech-software.com.ar/api/academy/valid-time?categoryId=${idcategoryselected}&formId=${idformselected}`);
        setMaxTime(response.data.duration); // Guardar la duración máxima
        setFormData((prevData) => ({ ...prevData, duration: response.data.duration })); // Actualizar el estado de duración
        console.log("Duración máxima disponible:", response.data.duration);
      } catch (error) {
        console.error("Error al obtener la duración válida:", error);
      }
    };

    fetchValidTime();
  }, [idcategoryselected, idformselected]);



  // Obtener eventos disponibles
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const eventDetailsResponse = await get(`/api/academy/events/${eventId}`);
        setEventoDetalles(eventDetailsResponse.data);
      } catch (error) {
        console.error("Error al cargar eventos:", error);
      }
    };

    fetchEventos();
  }, [schoolId]);

  // Obtener participantes
  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        const response = await get(`/api/academy/schools/${schoolId}/members?page=0&size=100&status=true`);
        setParticipants(response.data.content);
      } catch (error) {
        console.error("Error al cargar los participantes:", error);
      }
    };

    fetchParticipants();
  }, [schoolId]);



  /*Cambios en lo componentes del formulario*/
  // Manejar cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    if (name === "formas") {
      setIdformselected(value); // Guardar el ID de la forma seleccionada
      setSelectedParticipants([]); // D||eseleccionar participantes al cambiar la forma
    }

    if (name === "categoria") {
      setIdcategoryselected(value); // Guardar el ID de la categoría seleccionada
      setSelectedParticipants([]); // Deseleccionar participantes al cambiar la categoría
    }

    if (name === "modalidad") {
      
      setSelectedParticipants([]); // Deseleccionar participantes al cambiar la modalidad
    }

    if (name === "dance_performance_order") {
      setDancePerformanceOrder(value); // Guarda la selección en el estado
    }

    if (name === "nombre") {
      // Asegurar que la primera letra sea mayúscula
      const formattedValue = value.charAt(0).toUpperCase() + value.slice(1);
      setFormData((prevData) => ({ ...prevData, [name]: formattedValue }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }

  };

  // Manejar selección de participantes
  const handleParticipanteChange = (e) => {
    const { value, checked } = e.target;
    const participantId = value;

    if (!formDetails) {
      console.error("❌ formDetails no está disponible.");
      return;
    }

    if (checked && selectedParticipants.length >= formDetails.maximumtparticipants) {
      alert(`No puedes seleccionar más de ${formDetails.maximumtparticipants} bailarines.`);
      return;
    }

    const participant = {
      member: { id: participantId},
      type: { id: 1 }
    }
  
    // Actualizar estado de participantes seleccionados
    setSelectedParticipants(prev =>
      checked
          ? [...prev, participant].filter(
                (p, index, self) =>
                    self.findIndex(sp => sp.member.id === p.member.id) === index
            )
          : prev.filter(p => p.member.id !== participantId)
    )
  };


  // Manejar cambios en el checkbox de coreografía
const handleCoreografiaChange = (e) => {
  const checked = e.target.checked;
  setIsChoreography(checked);
  sethascoreographer(checked);

  // Obtener el precio de la coreografía y sumarlo o restarlo al totalPrice
  const priceCoreography = eventoDetalles.config.priceChoreography || 0;
  if (checked) {
    setTotalPrice((prevTotalPrice) => prevTotalPrice + priceCoreography);
  } else {
    setTotalPrice((prevTotalPrice) => prevTotalPrice - 0);
  }
};


  // Manejar cambios en el checkbox preparador
  const handlehasTrainerChange = (e) => {
    sethastrainer(e.target.checked);
    if (!e.target.checked) setTrainer(null); // Resetear el select si se desmarca
  };


  // Manejar cambios en el checkbox coreografo
  const handlehasCoregrapher = (e) => {
    sethascoreographer(e.target.checked);
    if (!e.target.checked) setCoreographer(null); // Resetear el select si se desmarca
  };


  // Manejar envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validar número de participantes
    if (selectedParticipants.length < formDetails?.minimumParticipants) {
      setError(`Debes seleccionar al menos ${formDetails.minimumParticipants} participantes.`);
      setLoading(false);
      return;
    }

    if (selectedParticipants.length > formDetails?.maximumtparticipants) {
      setError(`No puedes seleccionar más de ${formDetails.maximumtparticipants} participantes.`);
      setLoading(false);
      return;
    }

    const membersSelected = [...selectedParticipants, ...trainers, // descomprime el array
  ...(coregrapher ? [coregrapher] : [])
];
    

    // Crear payload para la solicitud POST
    const payload = {
      name: formData.nombre,
      duration: formData.duration, // Duración obtenida de la categoría
      musicTheme: formData.musicTheme,
      status: true,
      isChoreographed: isChoreography,
      contest: { id: 2 },
      category: { id: parseInt(formData.categoria, 10) },
      modality: { id: parseInt(formData.modalidad, 10) },
      totalPrice: totalPrice,
      order: parseInt(dancePerformanceOrder, 10),
      form: { id: parseInt(formData.formas, 10) },
      participants: membersSelected,
      
    };

    try {
      const response = await post(
        `/api/academy/events/registration/${registrationId}/performance`,
        payload
      );
      toast.success("Obra Creada con éxito.");
      onSuccess();
      setShowSuccessModal(true);
      onclose();
    } catch (error) {
      console.error("Error al enviar la solicitud:", error.response?.data || error.message);
      setError("Error al registrar la obra. Intente nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  // Manejar cierre del formulario
  const handleFormClose = () => {
    setFormData({
      nombre: '',
      categoria: '',
      modalidad: '',
      formas: '',
      duration: '',
      musicTheme: 'Default',
    });
    setSelectedParticipants([]);
    setIsChoreography(false);
    if (onclose) onclose();
  };

  // Verificar si el número de participantes seleccionados excede el máximo permitido
  useEffect(() => {
    if (formDetails) {
      const isDisabled =
        selectedParticipants.length > formDetails.maximumtparticipants ||
        selectedParticipants.length < formDetails.minimumParticipants;
      setIsRegistrationDisabled(isDisabled);
    }
  }, [selectedParticipants, formDetails]);


  const total_price = selectedParticipants.length *
    (eventoDetalles?.config?.forms?.find((forma) => forma.id === parseInt(formData.formas))?.price || 0);


  return (
    <div className="container mt-4">
      <h5 className="text-center mb-4 bg-primary text-white p-3 rounded">Nueva Obra</h5>
      <h5 className="text-center text-muted">Escuela N°: {registrationId}</h5>

      {error && <div className="alert alert-danger text-center">{error}</div>}

      <form onSubmit={handleSubmit} className="shadow-lg p-4 bg-light rounded">
        {/* Campo de nombre */}
        <div className="form-floating mb-3">
          <input
            type="text"
            id="nombre"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            className={`form-control ${errors.nombre ? "is-invalid" : ""}`}
            required
            placeholder="Nombre"
          />
          <label htmlFor="nombre">Nombre:</label>
          {errors.nombre && <div className="invalid-feedback">{errors.nombre}</div>}
        </div>



        {/* Selector de modalidad */}
        <div className="form-floating mb-3">
          <select
            id="modalidad"
            name="modalidad"
            value={formData.modalidad}
            onChange={handleChange}
            className={`form-control ${errors.modalidad ? "is-invalid" : ""}`}
            required
          >
            <option value="">Seleccionar Modalidad</option>
            {eventoDetalles?.config?.modalities
              ?.slice() // Copia el array para no mutar el original
              .sort((a, b) => a.id - b.id)// Ordena alfabéticamente
              .map((modalidad) => (
                <option key={modalidad.id} value={modalidad.id}>
                  {modalidad.name}
                </option>
              ))}
          </select>
          <label htmlFor="modalidad">Modalidad</label>
          {errors.modalidad && <div className="invalid-feedback">{errors.modalidad}</div>}
        </div>


        {/* Selector de forma */}
        <div className="form-floating mb-3">
          <select
            id="formas"
            name="formas"
            value={formData.formas}
            onChange={handleChange}
            className={`form-control ${errors.formas ? "is-invalid" : ""}`}
            required
          >
            <option value="">Seleccionar Forma</option>
            {eventoDetalles?.config?.forms
              ?.slice() // Copia el array para no mutar el original
              .sort((a, b) => a.name.localeCompare(b.name)) // Ordena alfabéticamente
              .map((forma) => (
                <option key={forma.id} value={forma.id}>
                  {forma.name}
                </option>
              ))}
          </select>
          <label htmlFor="formas">Forma</label>
          {errors.formas && <div className="invalid-feedback">{errors.formas}</div>}
        </div>


        {/* Mostrar detalles de la forma seleccionada */}
        {idformselected && (
          <div className="mt-1">
            <strong className="text-danger">Precio por participante: $</strong>
            <strong className="">{eventoDetalles?.config?.forms?.find((forma) => forma.id === parseInt(idformselected))?.price || 0}</strong>
          </div>
        )}

        {/* Selector de categoría */}
        <div className="form-floating mb-3 mt-3">
          <select
            id="categoria"
            name="categoria"
            value={formData.categoria}
            onChange={handleChange}
            className={`form-control ${errors.categoria ? "is-invalid" : ""}`}
            required
          >
            <option value="">Seleccionar Categoría</option>
            {eventoDetalles?.config?.categories
              ?.slice()
              .sort((a, b) => a.name.localeCompare(b.name)) // Ordena alfabéticamente
              .map((categoria) => (
                <option key={categoria.id} value={categoria.id}>
                  {categoria.name}
                </option>
              ))}
          </select>
          <label htmlFor="categoria">Categoría</label>
          {errors.categoria && <div className="invalid-feedback">{errors.categoria}</div>}
        </div>

        {/* Mostrar duración máxima */}
        {maxTime && (
          <div className="mt-1">
            <strong className="text-danger">Duración máxima disponible: </strong><strong>{maxTime}</strong><strong> minutos.</strong>
          </div>
        )}

        {/* Tabla de participantes */}
        <div className="form-group mb-3 mt-3">
          <label>Bailarines</label>

          {/* Mostrar cantidad de participantes seleccionados */}


          <table class="table table-striped table-hover">
            <thead className="table-primary">
              <tr>
                <th className="text-center">Seleccionar</th>
                <th className="text-center">Nombre y Apellido</th>
                <th className="text-center">Beca</th>
                {/*<th className="text-center">Rol</th>*/}
              </tr>
            </thead>
            <tbody>
              {participants.map((participant) => (
                <tr key={participant.id}>
                  <td className="d-flex justify-content-center align-items-center">
                    <input
                      type="checkbox"
                      id={`participante-${participant.id}`}
                      value={participant.id}
                      onChange={handleParticipanteChange}
                      className="form-check-input"
                      checked={selectedParticipants.some(p => p.member.id === participant.id.toString())}
                    />
                  </td>
                  <td className="text-left align-baseline">{participant.name} {participant.surname}</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/*Si tiene preparador*/}
        <div>
          <div className="form-group mb-3">
            <label className="text-center">
              <input type="checkbox" checked={hasatrainer} onChange={handlehasTrainerChange} />
              Maestro/a Preparador/a
            </label>
          </div>

          {hasatrainer && (
  <div className="form-group mb-3">
    <label htmlFor="trainers">Selecciona uno o más preparadores:</label>
    <select
      id="trainers"
      className="form-control"
      multiple
      value={trainers.map((t) => t.member.id)}
      onChange={(e) => {
        const selectedOptions = Array.from(e.target.selectedOptions).map(option => ({
          member: { id: Number(option.value) },
          type: { id: 2 }
        }));
        setTrainers(selectedOptions);
      }}
    >
      {participants.map((participante) => (
        <option key={participante.id} value={participante.id}>
          {participante.name} {participante.surname}
        </option>
      ))}
    </select>
    <small className="form-text text-muted">
      Mantené presionada <strong>Ctrl</strong> (o <strong>Cmd</strong> en Mac) para seleccionar varios.
    </small>
  </div>
)}


        </div>

        {/* Checkbox para indicar si tiene coreografo */}
        <div className="form-group mb-3">
          <label className="text-center">
            <input
              type="checkbox"
              checked={isChoreography}
              onChange={handleCoreografiaChange}
            />
            Concursa por coreografía
          </label>
        </div>

          {/*Si tiene coreógrafo /a*/}
        <div>
                    
          {hasacoregrapher && (
            <div className="form-group mb-3">
              <label htmlFor="coreographer">Selecciona un coreógrafo:</label>
              <select
                id="coreographer"
                className="form-control"
                value={coregrapher?.member?.id}
                onChange={(e) => setCoreographer({
                  member: { id: e.target.value },
                  type: { id: 3 }
                })}
              >
                <option value="">Seleccione Coreógrafo</option>
                {participants.map((participante) => (
                  <option key={participante.id} value={participante.id}>
                    {participante.name} {participante.surname}
                  </option>
                ))}
              </select>

            </div>
          )}

        </div>
        
        {/* Selector de orden de la obra */}
        <div className="form-floating mb-3">
          <select
            id="dance_performance_order"
            name="dance_performance_order"
            value={dancePerformanceOrder}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">Seleccionar orden</option>
            {[...Array(100)].map((_, index) => (
              <option key={index + 1} value={index + 1}>
                {index + 1}
              </option>
            ))}
          </select>
          <label htmlFor="dance_performance_order">Orden de la obra</label>
        </div>
        <strong className="text-secondary">
          Costo total: $ {totalPrice}
        </strong>

        {/* Botones de enviar y cancelar */}
        <div className="d-flex gap-2 mt-4">
          <button
            type="submit"
            className="btn btn-primary btn-sm w-50 d-flex align-items-center gap-2 justify-content-center"
            disabled={loading || isRegistrationDisabled}
          >
            <BsFillSendFill /> {loading ? "Enviando..." : "Registrar"}
          </button>

          <button
            type="button"
            className="btn btn-outline-secondary btn-sm w-50 d-flex align-items-center gap-2 justify-content-center"
            onClick={handleFormClose}
          >
            <BsFillXCircleFill style={{ marginRight: "5px" }} /> Cerrar
          </button>
        </div>
      </form>
      <SuccessModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} />
        <div>
          {/* ToastContainer */}
<ToastContainer 
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
        </div>
    </div>
    
  );
};

export default PerformanceForm;